import React from 'react';
import { setLocalActiveClass } from "../../../utils/helper";
import { Row, Col } from 'react-bootstrap';
import './5mmfittingstep2.scss';
import { Scrollbars } from "react-custom-scrollbars";
import SideMenu from '../../../components/sidebar/sidemenu'
import Header from '../../../components/header/header';
import FreespaceImg from '../../../assets/images/teethFreespace.svg';
import ReactPlayer from "../../../components/videoplayer/videoplayer";
import Button from "../../../components/Button/button";
import HomeSideMenu from '../../../components/homesidebar/homesidebar';

class FivemmFittingStep2 extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            isViewFrom: this.props.history.location.state.isViewFrom,
        }
        //   { this.state.isViewFrom === '3mm Touch Test' ? setLocalActiveClass("3mmFittingStep1") : setLocalActiveClass("5mmFittingStep1") }
        { this.state.isViewFrom === '3mm Touch Test' ? setLocalActiveClass("3mmFittingStep1") : (this.state.isViewFrom === 'home3mm' || this.state.isViewFrom === 'home5mm' ? setLocalActiveClass("HomeInstructions") : setLocalActiveClass("5mmFittingStep1")) }

        // setLocalActiveClass("5mmFittingStep1")
    }
    onNextStepClick() {
        { (this.state.isViewFrom === 'home3mm' || this.state.isViewFrom === 'home5mm') && this.props.history.push("/instructions", { isViewFrom: this.state.isViewFrom }) }
        // { this.state.isViewFrom === 'home3mm' ? this.props.history.push('/3mmfittingstep3', { isViewFrom: this.state.isViewFrom }) : this.props.history.push('/5mmFittingStep3', { isViewFrom: this.state.isViewFrom }) }
        // this.props.history.push('/5mmFittingStep3', { isViewFrom: this.state.isViewFrom })
    }

    render() {
        let headerData = this.state.isViewFrom === '3mm Touch Test' || this.state.isViewFrom === 'home3mm' ? '3mm Fitting - Fitting Guide' : '5mm Fitting - Fitting Guide'
        return (
            <div className='main-5mmFitting2'>
                <Header></Header>
                {/* <SideMenu {...this.props}></SideMenu> */}
                {this.state.isViewFrom === 'home3mm' || this.state.isViewFrom === 'home5mm' ? <HomeSideMenu {...this.props} showMorePopup={true}></HomeSideMenu> : <SideMenu {...this.props}></SideMenu>}
                <div className='inner-5mmFitting2'>
                    <Scrollbars>
                        <div className='main-Container'>
                            <div className='img-Container'>
                                <img src={FreespaceImg} className="logo" alt="logo" />
                            </div>
                            <h2 className='paddingB15'>{headerData}</h2>
                            <div className='content-Section'>
                                <h5 className='paddingB15'>Fitting your Oralift device is easy</h5>
                            </div>
                            {/* <VideoPlayer></VideoPlayer> */}
                            <ReactPlayer url={this.state.isViewFrom !== 'home5mm' ? "https://vimeo.com/426036134/8f3efaf82d" : "https://vimeo.com/448647023/2b9508bc9e"} controls={true}></ReactPlayer>
                            <div className='content-Section paddingB40'>
                                <h3 className='paddingB15'>Step 2: Fitting</h3>
                                <h5 className='paddingB15'>Make sure you do not bite too hard otherwise you may distort the device.</h5>
                            </div>
                            <Button
                                title="go to instruction"
                                onClick={() => this.onNextStepClick()}
                            ></Button>
                        </div>
                    </Scrollbars>
                </div>
            </div>

        )
    }
}




export default FivemmFittingStep2;

